<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$(document).on('click', '.pagination-page-infinite a.button', function(e) {
    console.log("Show More button clicked!");
    
    // Slight delay for new products to load and button state to update
    setTimeout(function() {
      // Check if a disabled button now exists
      if ($('.pagination-page-infinite a.button').hasClass('disabled')) {
        console.log("Button is now disabled. Showing out-of-stock products...");

        // Reveal out-of-stock products
        $('.product:not(.istock)').css('height', 'unset');
        $('.product:not(.istock)').css('position', 'relative');
      }
    }, 3200); // Adjust if needed based on your actual load speed
  });